import api from '@/api/api.js'

export default {
    getAssurances() {
        const promise = api.clinique().get('/assurances')
        return promise.then(response => response.data)
    },

    getSocieteByAssurance(assurance_id) {
        const promise = api.clinique().get('/assurances/souscripteurs/'+assurance_id+'/liste')
        return promise.then((response) => response.data)
    },

    getFactureRembourse(data) {
        const promise = api.clinique().post('/assurances/facture/demande-rembourse', data)
        return promise.then(response => response.data)
    },

    getGroupeAssuranceActif() {
        const promise = api.clinique().get('/groupes/assurances/actif')
        return promise.then(response => response.data)
    },

    getInfoPatientAssure(patient_id) {
        const promise = api.clinique().get('/patients/'+patient_id+'/info_assure')
        return promise.then(response => response.data)
    },

    getSouscripteurGroupByAssurance(data) {
        const promise = api.clinique().post('/assurances/liste-souscripteurs', data)
        return promise.then(response => response.data)
    },

    updateSouscripteursForfaitaires(data) {
        const promise = api.clinique().post('/assurances/souscripteurs/update-liste-forfaitaires', data)
        return promise.then(response => response.data)
    },

    updateMontantForfaitaire(data) {
        const promise = api.clinique().post('/assurances/souscripteurs/update-montant-forfaitaires', data)
        return promise.then(response => response.data)
    },

    updateInfoSociete(data) {
        const promise = api.clinique().post('/assurances/souscripteurs/update-info-societe', data)
        return promise.then(response => response.data)
    },

    getInfoSocieteByID(societe_id) {
        const promise = api.clinique().get('/assurances/souscripteurs/' + societe_id + '/get-info-societe')
        return promise.then(response => response.data)
    },
}